const Pay = Object.freeze({
    KASPI: 'KASPI',
    UNDEFINED: 'UNDEFINED',
    CREDITCARD: 'CREDITCARD',
    PAYMENTPICKUP: 'PAYMENTPICKUP',
  });
  
  export default Pay;